import React, { useEffect } from 'react';
import Icon from '@/components/ui/Icon';
import { toast } from '@/components/ui/Toast';
import cn from '@/utils/cn';

interface UseToastAfterReloadOptions {
  autoClose?: number | false;
}

const useToastAfterReload = (
  reloadKey: string,
  options?: UseToastAfterReloadOptions,
) => {
  useEffect(() => {
    const message = sessionStorage.getItem(reloadKey);
    if (!message) return;

    sessionStorage.removeItem(reloadKey);

    requestAnimationFrame(() => {
      toast.show(
        <span className="tw-flex tw-items-center tw-gap-3 tw-text-sm">
          <span
            className={cn(
              'tw-inline-flex tw-items-center tw-justify-center',
              'tw-w-7 tw-h-7 tw-rounded-full tw-bg-green tw-shrink-0',
            )}
          >
            <Icon fill="white" icon="Check" size={14} />
          </span>
          <span className="tw-flex-1">{message}</span>
          <button
            aria-label="Close notification"
            className={cn(
              'tw-shrink-0 tw-bg-transparent tw-border-none',
              'tw-cursor-pointer tw-p-0',
            )}
            type="button"
            onClick={() => toast.dismiss(reloadKey)}
          >
            <Icon fill="#6b7280" icon="Close" size={16} />
          </button>
        </span>,
        { closeButton: false, toastId: reloadKey, ...options },
      );
    });
  }, []);

  const setToastMessage = (msg: string) => sessionStorage.setItem(reloadKey, msg);

  return { setToastMessage };
};

export default useToastAfterReload;
